const steps = [
  {
    number: "01",
    title: "Consultation",
    subtitle: "Discovery & Strategy",
    description: "We start with a deep-dive call to understand your business, goals, and target audience. We map out a clear strategy before a single pixel is designed.",
    deliverables: ["Business Goals Audit", "Competitor Analysis", "Project Roadmap", "Timeline & Pricing"],
    duration: "1–2 Days",
    icon: "ri-discuss-line",
  },
  {
    number: "02",
    title: "Design & Build",
    subtitle: "Creation Phase",
    description: "Our team crafts your custom design and builds it with clean, fast code. You get regular updates and can provide feedback throughout the process.",
    deliverables: ["Custom UI Design", "Responsive Development", "Content Integration", "Performance Tuning"],
    duration: "7–10 Days",
    icon: "ri-tools-line",
  },
  {
    number: "03",
    title: "Launch & Optimize",
    subtitle: "Go Live & Grow",
    description: "We launch your site, set up analytics, and monitor performance. Then we optimize based on real data to keep improving your results over time.",
    deliverables: ["Live Deployment", "Analytics Setup", "SEO Configuration", "Ongoing Support"],
    duration: "1–2 Days",
    icon: "ri-rocket-line",
  },
];

import { Link } from "react-router-dom";

export default function ProcessSection() {
  return (
    <section id="process" className="py-28 bg-[#080b18]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase mb-4 block">How It Works</span>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-4">
            A Simple, Streamlined<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">Process That Delivers</span>
          </h2>
          <p className="text-white/50 text-base max-w-md mx-auto">
            A clear, efficient process designed to get you results fast — without the back-and-forth chaos.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#d4af37]/20 to-transparent -translate-x-1/2"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className={`flex flex-col lg:flex-row items-start lg:items-center gap-8 ${
                  index % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
              >
                {/* Content */}
                <div className="flex-1 lg:max-w-[calc(50%-60px)]">
                  <div className={`p-8 rounded-2xl border border-white/5 bg-[#0c0f1c] hover:border-[#d4af37]/20 transition-all duration-300 ${
                    index % 2 === 1 ? "lg:ml-auto" : ""
                  }`}>
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/20">
                        <i className={`${step.icon} text-[#d4af37] text-lg`}></i>
                      </div>
                      <span className="text-white/30 text-xs font-semibold tracking-widest uppercase">{step.duration}</span>
                    </div>
                    <h3 className="text-white font-black text-xl mb-1">{step.title}</h3>
                    <div className="text-[#d4af37] text-sm font-medium mb-4">{step.subtitle}</div>
                    <p className="text-white/50 text-sm leading-relaxed mb-6">{step.description}</p>
                    <div className="grid grid-cols-2 gap-2">
                      {step.deliverables.map((item) => (
                        <div key={item} className="flex items-center gap-2 text-white/40 text-xs">
                          <i className="ri-check-line text-[#d4af37]"></i>
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Center Number */}
                <div className="hidden lg:flex flex-shrink-0 w-24 h-24 items-center justify-center rounded-full border border-[#d4af37]/20 bg-[#0c0f1c] relative z-10">
                  <span className="text-[#d4af37] font-black text-2xl">{step.number}</span>
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Learn More CTA */}
        <div className="text-center mt-16">
          <Link
            to="/about#process"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#d4af37]/30 text-[#d4af37] text-sm font-semibold hover:bg-[#d4af37]/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            See Full Process Details
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
